import * as React from "react";
import UniversalLink from "§/src/utils/UniversalLink"

/**
 * Internal dependencies.
 */
import './_breadcrumb.scss';

// Language
 import { useTranslation } from 'react-i18next';

const Breadcrumb = ( props ) => {

  const { t } = useTranslation();
  const mainCategory = props.maincatName;
  const mainCategoryUri = props.maincatUri;
  const subCategory = props.subcatName;

  const originalUrl = props.wpseo[props.wpseo.length - 2].url;
  const productUrl = originalUrl.substring(0, originalUrl.lastIndexOf('/', originalUrl.lastIndexOf('/') - 1) + 1);

  // set atom class
  const atomClassName = 'breadcrumb';
  var atomClass = props.className !== undefined ? atomClassName + ' ' + props.className : atomClassName;

  return (
    <nav className={ atomClass } aria-label="breadcrumb">
      <ol className="breadcrumb">
        <li className="breadcrumb-item">
        <UniversalLink to='/'>{t('Home')}</UniversalLink>
        </li>
        <li className="breadcrumb-item"><UniversalLink to={productUrl}>{t('Prodotti')}</UniversalLink></li>
        <li className="breadcrumb-item active" aria-current="page">
          <UniversalLink to={mainCategoryUri}>{mainCategory}</UniversalLink>
        </li>
        <li className="breadcrumb-item active" aria-current="page">{subCategory}</li>
      </ol>
    </nav>
  )
}

export default Breadcrumb
